import { render, staticRenderFns } from "./Backdrop.vue?vue&type=template&id=1fb804aa&scoped=true&"
import script from "./Backdrop.vue?vue&type=script&lang=js&"
export * from "./Backdrop.vue?vue&type=script&lang=js&"
import style0 from "./Backdrop.vue?vue&type=style&index=0&id=1fb804aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb804aa",
  null
  
)

export default component.exports